import { useEffect, useState } from "react";

const AddToHomeBanner = () => {
  const [visible, setVisible] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isWebBrowser, setIsWebBrowser] = useState(false);

  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=online.matubyte.deportivospro&pcampaignid=web_share";

  useEffect(() => {
    // Verificar si está en un navegador web
    const checkIfWebBrowser = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isInWebBrowser =
        !window.matchMedia("(display-mode: standalone)").matches &&
        !window.navigator.standalone &&
        !document.referrer.includes("android-app://") &&
        !userAgent.includes("wv"); // No es WebView

      setIsWebBrowser(isInWebBrowser);
      return isInWebBrowser;
    };

    // Verificar si la app ya está instalada
    const checkIfInstalled = () => {
      const isStandalone =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone ||
        document.referrer.includes("android-app://");

      setIsInstalled(isStandalone);
      return isStandalone;
    };

    // Verificar si el usuario ya descartó el banner
    const checkIfDismissed = () => {
      return localStorage.getItem("appBannerDismissed") === "true";
    };

    // Mostrar el banner si cumple todas las condiciones
    const shouldShowBanner = () => {
      const inWebBrowser = checkIfWebBrowser();
      const appInstalled = checkIfInstalled();
      const dismissed = checkIfDismissed();

      if (inWebBrowser && !appInstalled && !dismissed) {
        // Mostrar después de un delay más largo para ser menos molesto
        setTimeout(() => setVisible(true), 5000);
      }
    };

    // Inicializar
    shouldShowBanner();

    // Verificar periódicamente cambios de estado
    const checkInterval = setInterval(() => {
      if (checkIfInstalled()) {
        setVisible(false);
      }
    }, 5000);

    return () => {
      clearInterval(checkInterval);
    };
  }, []);

  // Función para manejar la instalación (redirigir a Play Store)
  const handleInstall = () => {
    try {
      localStorage.setItem("appBannerDismissed", "true");
      window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
      setVisible(false);
      console.log("Redirigiendo a Play Store");
    } catch (error) {
      console.error("Error al abrir Play Store:", error);
    }
  };

  // Función para descartar el banner
  const handleDismiss = () => {
    localStorage.setItem("appBannerDismissed", "true");
    setVisible(false);
  };

  // Auto-ocultar después de 15 segundos si el usuario no interactúa
  useEffect(() => {
    if (visible) {
      const autoHideTimer = setTimeout(() => {
        setVisible(false);
      }, 15000);

      return () => clearTimeout(autoHideTimer);
    }
  }, [visible]);

  // Si no debe mostrarse, no renderizar nada
  if (!visible || !isWebBrowser || isInstalled) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 max-w-xs animate-slideIn">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
        {/* Header compacto */}
        <div className="bg-blue-600 px-3 py-2 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-6 h-6 bg-white rounded-md flex items-center justify-center">
              <svg
                className="w-4 h-4 text-blue-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
              </svg>
            </div>
            <span className="text-white text-sm font-medium">
              Deportivos Pro
            </span>
          </div>
          <button
            onClick={handleDismiss}
            className="text-blue-200 hover:text-white transition-colors"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>

        {/* Contenido */}
        <div className="p-3">
          <p className="text-gray-700 text-sm mb-3">
            ¡Descarga nuestra app para una mejor experiencia!
          </p>

          <div className="flex space-x-2">
            <button
              onClick={handleInstall}
              className="flex-1 bg-blue-600 text-white text-sm font-medium py-2 px-3 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center space-x-1"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
              <span>Descargar</span>
            </button>
            <button
              onClick={handleDismiss}
              className="text-gray-500 hover:text-gray-700 text-sm px-2 transition-colors"
            >
              Ahora no
            </button>
          </div>
        </div>

        {/* Pequeño indicador de Play Store */}
        <div className="bg-gray-50 px-3 py-1 flex items-center justify-center space-x-1">
          <svg
            className="w-3 h-3 text-gray-400"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
          </svg>
          <span className="text-gray-500 text-xs">Google Play</span>
        </div>
      </div>

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate-slideIn {
          animation: slideIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default AddToHomeBanner;
